export default function(ring) {
  var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
  while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
  return area;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-contour/src/area.js
// module id = ./node_modules/d3-contour/src/area.js
// module chunks = 54